import lazysizes from 'lazysizes'
import 'lazysizes/plugins/parent-fit/ls.parent-fit'
import NoticeGlobal from 'snippets/notice-global/notice-global'
import ModalBookingLayout from 'modules/modal-booking/modal-booking'
import register from 'preact-custom-element'
import 'libs/accessibility'
import 'styles/theme.css'
import 'snippets/video-player/video-player'
import 'snippets/accordion-list/accordion-list'
import 'modules/carousel-swiper/carousel-swiper-custom'
import 'snippets/modal-dialog/modal-dialog'
import 'snippets/notice-main/notice-main'
import 'snippets/read-more/read-more'
import 'snippets/validate-form/validate-form'
import 'snippets/slideout/slideout'
import 'snippets/form/custom-input-password/custom-input-password'
import 'snippets/form/text-input/input'

register(NoticeGlobal, 'notice-global')
register(ModalBookingLayout, 'modal-booking')

lazysizes.init()
